import { withInstall } from '@element-plus/utils'

import Divider from './src/divider.vue'

export const ElDivider = withInstall(Divider)
export default ElDivider

export * from './src/divider'
